import { apiDomain } from "env";

const menus = (product = "portal-beneficiario") =>
  `${apiDomain}/administracao/menus/${product}`;

export default {
  menus
};
